let first_name = {};

first_name = require('../data/first_name')

module.exports = first_name;